import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlMorfologico/getFiltrarModalInicio`, method: 'POST', body: values, token: token})
}
